export default __webpack_public_path__ + "static/media/5.6c2ec561.png";